<template>
  <div id="app" :class="{ 'minW': isPC }">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  watch: {
    '$route': function () {
      this.scrollToTop()
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  }
}
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
}

.minW {
  min-width: 120rem;
}
</style>
